import 'swiper/dist/css/swiper.css'
import mediasMixins from 'root/mixins/mediasMixin.js'
import utilsMixin from 'root/mixins/utilsMixin.js'
import quickProductMixin from 'root/mixins/quickProductMixin.js'

import closeImage from 'assets/img/svg/close.svg'
import empaqueImage from 'assets/img/svg/empaque.svg'
import tiendaImage from 'assets/img/svg/tienda.svg'
import empaqueGrayImage from 'assets/img/svg/empaque-gray.svg'
import tiendaGrayImage from 'assets/img/svg/tienda-gray.svg'
import iconPlus from 'assets/img/svg/plus.svg'
import iconAlert from 'assets/img/svg/circle-exclamation-solid.svg'
import iconMinus from 'assets/img/svg/minus.svg'
import arrowBack from 'assets/img/svg/arrow-back.svg'
import arrowNext from 'assets/img/svg/arrow-next.svg'

export default {
  name: 'product-quick-view',
  mixins: [mediasMixins, utilsMixin, quickProductMixin],

  props: [
    'inheritedquickproduct',
    'modalreferenceshow',
    'urlprefix'
  ],

  data () {
    const vue = this
    return {
      parentVariantSelected: undefined,
      variantSelectedByUser: undefined,
      iconPlus: iconPlus,
      iconMinus: iconMinus,
      arrowBack: arrowBack,
      arrowNext: arrowNext,
      iconAlert: iconAlert,
      itemQuantity: 1,
      closeImage: closeImage,
      empaqueImage: empaqueImage,
      tiendaImage: tiendaImage,
      tiendaGrayImage: tiendaGrayImage,
      empaqueGrayImage: empaqueGrayImage,
      CSRFToken: vue.$root.CSRFToken,
      productAddedLessQtyMsg: 'A lower quantity of this product has been added to your cart due to insufficient stock ',
      quickProduct: null,
      quickvariantsswiperoptions: {
        spaceBetween: 10,
        preloadImages: true,
        navigation: {
          nextEl: '.quick-variants-button-next',
          prevEl: '.quick-variants-button-prev'
        },
        slidesPerView: 5,
        breakpoints: {
          1023: {
            slidesPerView: 5
          }
        }
      },
      errorMsj: '',
      errorQtyAbl:'',
      errorQty : false
    }
  },

  methods: {
    selectVariant(variantUrl) {
      this.variantSelectedByUser = variantUrl;
    },

    closeModal () {
      this.$parent.$emit('closeReferenceModal')
      setTimeout(function () {
        this.itemQuantity = 1
        this.errorMsj = ''
        this.errorQty = false
        this.resetModal()
      }.bind(this), 500)
    },

    addQty () {
      this.itemQuantity++
    },

    lessQty () {
      if (this.itemQuantity > 1) {
        this.itemQuantity--
      }
    },

    onBlur (itemQuantity) {
      if (itemQuantity < 1) {
        setTimeout(function () {
          this.itemQuantity = 1
        }.bind(this), 500)
      }
    },
    onKeypress (itemQuantity) {
      if(isNaN(itemQuantity)){
        return false;
      }
    },

    sendForm (event) {
      var $this = this
      event.preventDefault()
      if(this.loading) {return}
      if((_.get(this.selectRef, 'selectedIndex', 1) <= 0)) { this.showMsgTallaNotSelected = true; return}

      // send get request
      function toJSONString (form) {
        var obj = {}
        var elements = form.querySelectorAll('input, select, textarea')
        for (var i = 0; i < elements.length; ++i) {
          var element = elements[i]
          var name = element.name
          var value = element.value
          if (name) {
            obj[ name ] = value
          }
        }
        return obj
      }

      var addToCartForm = _.isArray(this.$refs.addToCartForm) ? this.$refs.addToCartForm[0] : this.$refs.addToCartForm
      let formData = toJSONString(addToCartForm)
      this.$http.post(addToCartForm.action, formData, {
        emulateJSON: true,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        before: function () {
          this.$root.showloader = true
        }
      }).then(response => {
        if (response.body.error) {
          if (_.get(response, 'body.productadded', null) && response.body.error == $this.productAddedLessQtyMsg) {
            this.$root.$emit('added--product', response.body.productadded, response.body.error)
          } else {
            this.$root.$emit('added--product', null, response.body.error)
          }
        } else {
          if (response.body.cartData.errorMessage !== '' ) {
            this.errorMsj = response.body.cartData.errorMessage
            this.errorQty = true
             return
          }else{
            if (_.get(response, 'body.productadded', null)) {
              this.$root.$emit('added--product', response.body.productadded)
              this.errorMsj = ''
              this.errorQty = false
            }
          }
        }
        this.$parent.$emit('closeReferenceModal')
        this.itemQuantity = 1
      }, error => {
        console.error(error)
      }).finally(function () {
        this.$root.showloader = false
        this.scrolltop()
      })
    }
  },

  computed: {
    itemQuantityNotValid () {
      return isNaN(this.itemQuantity);
    },

    variantSelected() {
      return this.variantSelectedByUser || _.get(this.computedQuickProduct, 'product.code') + '/quickView'
    },
    hasVariantTalla () {
      return _.get(this.computedQuickProduct, 'varianttallalist.length') > 1
    },
    hasVariantMonto () {
      if(!this.quickProduct){
        return !!_.get(this.inheritedquickproduct, 'variantmontolist.length')
      } else {
        return !!_.get(this.quickProduct, 'variantmontolist.length')
      }
    },
    computedQuickProduct () {
      return this.quickProduct || this.inheritedquickproduct || null
    },
    
    selectRef() {
      return _.first(this.$refs.tallael)
    }
  },
  
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  
  mounted: function(){
    var $this = this;
    this.$parent.$on('closeReferenceModal', _.bind(function () {
      this.lastSizeSelected = null
    }, this))
  },

  created: function() {
    this.$root.$on('clean-modal-error-messages', _.bind(function () {
      setTimeout(function () {
        this.itemQuantity = 1
        this.errorMsj = ''
        this.errorQty = false
      }.bind(this), 500)
    },this))
  },

  watch: {
    inheritedquickproduct () {
      this.quickProduct = null
    }
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/product/productquickview/productquickview.js